module.exports = __webpack_public_path__ + "static/img/single_item_image1.cf80f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/single_item_image1.png
// module id = Fblq
// module chunks = 1